import * as _ from "lodash";
import { action, observable, makeObservable } from "mobx";
import {
  approveSnippet,
  getDocument,
  getDocuments,
  rejectSnippet,
} from "../../serviceCalls";
import { DateTime } from "luxon";

export default class DocumentsStore {
  documents;
  documentsLoading;
  selectedDocumentItem;
  document;
  documentLoading;
  zoom = 1;

  approveSnippet = approveSnippet;
  rejectSnippet = rejectSnippet;

  constructor() {
    makeObservable(this, {
      documents: observable,
      documentsLoading: observable,
      selectedDocumentItem: observable,
      document: observable,
      documentLoading: observable,
      zoom: observable,
      selectDocumentItem: action,
      fetchDocuments: action,
    });
  }

  selectDocumentItem(params) {
    this.selectedDocumentItem = params;
    if (params.documentId && params.parentId && params.asmpid) {
      this.fetchDocument(params);
    } else {
      this.document = null;
    }
  }

  documentIsSelected(documentItem) {
    return (
      documentItem.documentId === _.get(this.selectedDocumentItem, "documentId")
    );
  }

  async fetchDocument(params) {
    this.documentLoading = true;
    this.document = null;
    this.zoom = 1;
    const doc = await getDocument(params).finally(
      () => (this.documentLoading = false),
    );
    return (this.document = addDocDateTime(doc));
  }

  fetchDocuments(asmpid) {
    this.documentsLoading = true;
    return (
      getDocuments(asmpid)
        // The documents should be sorted by createdTime, most recent first, and then null values at the bottom.
        .then((res) => {
          this.documents = res.documents
            .map(addDocDateTime)
            .sort((a, b) => msOrZero(b.dateTime) - msOrZero(a.dateTime));
        })
        .finally(() => (this.documentsLoading = false))
    );
  }
}

function addDocDateTime(doc) {
  // destructure the snippetBeginDateTime and createdTime from the doc
  const { snippetBeginDateTime, createdTime } = doc;

  let documentDateTime;

  // check if the snippetBeginDateTime is null or 0001-01-01T00:00:00Z (min value from SQL server)
  if (!snippetBeginDateTime || snippetBeginDateTime.startsWith("0001")) {
    documentDateTime = createdTime;
  } else {
    documentDateTime = snippetBeginDateTime;
  }

  // convert to luxon DateTime
  const dateTime = DateTime.fromISO(documentDateTime);

  // validate the DateTime
  if (!dateTime.isValid) {
    // Handle error - either throw or log
    return {
      ...doc,
      dateTime: "Invalid DateTime",
    };
  }

  // return the document with the DateTime added
  return {
    ...doc,
    dateTime,
  };
}

function msOrZero(dateTime) {
  return dateTime.isValid ? dateTime : Number.MIN_SAFE_INTEGER;
}
